module.exports = __webpack_public_path__ + "static/media/not-take-exam.00b329f7.svg";